module.exports = {"app.title":"你好 世界!"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/zh.json
// module id = 265
// module chunks = 4